export const prepareEditorContentForUpload = (html, images) => {
  const documentNode = new DOMParser().parseFromString(html, "text/html");
  const embeddedImages = Array.from(documentNode.querySelectorAll("img")).filter(
    (image) => image.getAttribute("src")?.startsWith("data:image")
  );

  embeddedImages.forEach((image, index) => {
    const metadata = images[index];
    if (!metadata) return;

    image.removeAttribute("src");
    image.setAttribute("title", metadata.title || metadata.file?.name || "image");
    image.removeAttribute("alt");
    if (metadata.width) image.setAttribute("width", String(metadata.width));
    if (metadata.height) image.setAttribute("height", String(metadata.height));
  });

  return documentNode.body.innerHTML;
};
